// Shapes returned by the /effort routes, plus small formatters.

export type EffortProblem = 'no_tag' | 'unknown_tag' | 'two_tags';

export const PROBLEM_LABEL: Record<EffortProblem, string> = {
  no_tag: 'No tag',
  unknown_tag: 'Unknown tag',
  two_tags: 'Two tags',
};

export const PROBLEM_TONE: Record<EffortProblem, string> = {
  no_tag: 'bg-amber-50 text-amber-800 ring-amber-200',
  unknown_tag: 'bg-orange-50 text-orange-800 ring-orange-200',
  two_tags: 'bg-violet-50 text-violet-700 ring-violet-200',
};

export interface EffortTotals {
  entries: number;
  hours: number;
  valid: number;
  need_fix: number;
  need_fix_hours: number;
  valid_pct: number | null;
  by_problem: { no_tag: number; unknown_tag: number; two_tags: number };
}

export interface EffortProjectRow extends EffortTotals {
  project_key: string;
  project_name: string | null;
}

export interface EffortTrendPoint {
  period: string;
  entries: number;
  valid: number;
  valid_pct: number | null;
}

export interface EffortSummary {
  period: string;
  tagging_started: boolean;
  overall: EffortTotals | null;
  projects: EffortProjectRow[];
  trend: EffortTrendPoint[];
}

export interface FixRow {
  id: string;
  issue_key: string;
  issue_name: string | null;
  issue_type: string | null;
  project_key: string;
  jira_url: string;
  started: string;
  hours: number;
  comment: string | null;
  problem: EffortProblem;
  written: string | null;
  suggestion: string | null;
  hint: string;
  person: { account_id: string; name: string | null };
}

export interface FixPerson {
  account_id: string;
  name: string | null;
  entries: number;
  need_fix: number;
  valid_pct: number | null;
}

export interface NoTimeRow {
  issue_key: string;
  issue_name: string | null;
  issue_type: string | null;
  project_key: string;
  jira_url: string;
  assignee: { account_id: string; name: string | null } | null;
  since: string;
  days: number;
  stale: boolean;
}

export interface NoTimeData {
  threshold_days: number;
  stale_after_days: number;
  total: number;
  recent: number;
  stale: number;
  by_project: { project_key: string; project_name: string | null; count: number; recent: number }[];
  items: NoTimeRow[];
}

export interface QuietRow {
  account_id: string;
  name: string | null;
  last_logged: string;
  entries_before: number;
  hours_before: number;
}

export interface QuietData {
  window_days: number;
  lookback_days: number;
  total: number;
  items: QuietRow[];
}

export interface GapsData {
  no_time: NoTimeData;
  quiet: QuietData;
}

// Green from 90, amber from 70. A tag is easy to add, so the bar is higher than for Hygiene.
export function tagTone(pct: number | null): string {
  if (pct === null) return 'text-gray-500';
  if (pct >= 90) return 'text-emerald-700';
  if (pct >= 70) return 'text-amber-700';
  return 'text-rose-700';
}
